import { injectable } from 'tsyringe';
import type { PermissionEntry } from '@bmai/auth-api-client';
import { authClient } from '@/shared/AuthApiClient';

@injectable()
export class PermissionsAdminService {
    async listPermissions(): Promise<PermissionEntry[]> {
        return authClient.permissionsApi.getPermissions();
    }
}
